<template>
  <div class="d-flex justify-content-end align-items-center mb-1">
    <slot name="avisos-baixa-lote" />
    <button
      v-if="!possuiAgrupador"
      v-b-tooltip.hover
      :style="alterarStyle"
      title="O download será feito conforme os filtros atualmente selecionados"
      class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
      @click="abrirModal()"
    >
      <feather-icon
        icon="DownloadIcon"
        size="18"
      />
      <span class="ml-50">Baixar {{ tipoArquivo }}</span>
    </button>
    <b-dropdown
      v-else
      v-b-tooltip.hover
      variant="outline-primary"
      size="sm"
      :style="alterarStyle"
      style="white-space: nowrap;"
      toggle-class="d-inline-flex align-items-center"
      right
      title="O download será feito conforme os filtros atualmente selecionados"
    >
      <template #button-content>
        <feather-icon
          icon="DownloadIcon"
          size="18"
        />
        <span class="ml-50">Baixar {{ tipoArquivo }}</span>
      </template>
      <b-dropdown-item
        v-for="(opcao, index) in agrupadores"
        :key="index"
        @click="agrupador = opcao; abrirModal()"
      >
        {{ opcao.nome || opcao }}
      </b-dropdown-item>
    </b-dropdown>
    <b-modal
      id="modal-download"
      ref="modal-download"
      title="Exportar itens"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-footer>
        <button
          class="btn btn-sm btn-danger"
          @click="fecharModal"
        >
          Cancelar
        </button>
        <button
          class="btn btn-sm btn-success"
          :disabled="baixando"
          @click="baixarEmLote"
        >
          Baixar
        </button>
      </template>
      <b-form-group
        label="Nome do arquivo"
        label-for="nome-arquivo-input"
      >
        <b-form-input
          id="nome-arquivo-input"
          v-model="nomeArquivo"
          placeholder="Selecione o nome do arquivo"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<style lang="scss">
.col-valores{
  white-space: nowrap;
}

[dir] #baixaEmLoteSelect {
  /* empty */
}
</style>

<script>
import {
  getUserInfo,
} from '@/auth/utils'

export default {
  components: {
  },
  props: {
    tipoArquivo: {
      type: String,
      default: 'todas as certidões',
    },
    tipo: {
      type: String,
      default: '',
    },
    filtro: {
      type: Array,
      default: () => [],
    },
    palavrasFiltro: {
      type: Array,
      default: () => [],
    },
    possuiAgrupador: {
      type: Boolean,
      default: false,
    },
    agrupadores: {
      type: Array,
      default: () => [],
    },
    alterarStyle: {
      type: String,
      default: 'font-size: 11.5px;padding: .40rem;',
    },
  },
  data() {
    return {
      nomeArquivo: this.nomePadrao,
      nomeEmpresa: getUserInfo().empresa,
      agrupador: null,
      baixando: false,
    }
  },
  computed: {
    nomePadrao: {
      get() {
        const data = new Date()
        return `${this.tipo}-${this.nomeEmpresa}${this.palavrasFiltroSelecionada}-${data.getDate()}-${data.getMonth() + 1}-${data.getFullYear()}`
      },
    },
    palavrasFiltroSelecionada: {
      get() {
        let resultado = ''
        for (let i = 0; i < this.filtro.length;) {
          const filtroAtual = this.filtro[i]
          for (let j = 0; j < this.palavrasFiltro.length;) {
            const index = this.palavrasFiltro[j].findIndex(x => filtroAtual.label && filtroAtual.label.includes(x))
            if (index > -1) {
              resultado += `-${this.palavrasFiltro[j][index]}`
            }
            j += 1
          }
          i += 1
        }
        return resultado
      },
    },
  },
  watch: {
    filtro: {
      deep: true,
      handler() {
        this.atualizarNome()
      },
    },
  },
  created() {
    this.nomeArquivo = this.nomePadrao
  },
  methods: {
    baixarEmLote() {
      if (this.baixando) return
      this.baixando = true
      if (this.possuiAgrupador) {
        this.$emit('baixar-lote', { nomeArquivo: this.nomeArquivo, agrupador: this.agrupador })
      } else {
        this.$emit('baixar-lote', this.nomeArquivo)
      }
      this.fecharModal()
      setTimeout(() => {
        this.baixando = false
      }, 1000)
    },
    fecharModal() {
      this.$refs['modal-download'].hide()
      this.agrupador = null
    },
    abrirModal() {
      this.baixando = false
      this.$refs['modal-download'].show()
    },
    atualizarNome() {
      this.nomeArquivo = this.nomePadrao
    },
  },
}
</script>
